import { tailwindOverride } from '@getsynapse/design-system';
import AggregatedTrend from './AggregatedTrend';
import { TrendData } from './types';

type DefaultChartWithTrendSupportProps = {
  chartComponent: React.ReactElement;
  trendData?: TrendData;
  className?: string;
};

function DefaultChartWithTrendSupport({
  chartComponent,
  trendData,
  className,
}: DefaultChartWithTrendSupportProps) {
  return (
    <div className={tailwindOverride(className, 'h-full w-full flex flex-col')}>
      {trendData && <AggregatedTrend {...trendData} />}
      <div className='flex-1 relative'>
        <div className='w-full h-full absolute'>{chartComponent}</div>
      </div>
    </div>
  );
}

export default DefaultChartWithTrendSupport;
